import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c73279e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer-items" }
const _hoisted_3 = { class: "footer-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "FitTrackee", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-item bullet" }, "•", -1))
const _hoisted_6 = { class: "footer-item" }
const _hoisted_7 = {
  key: 0,
  class: "footer-item bullet"
}
const _hoisted_8 = {
  key: 1,
  class: "footer-item"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-item bullet" }, "•", -1))
const _hoisted_11 = { class: "footer-item" }
const _hoisted_12 = {
  href: "https://samr1.github.io/FitTrackee/",
  target: "_blank",
  rel: "noopener noreferrer"
}

import { toRefs } from 'vue'

  interface Props {
    version: string
    adminContact?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    version: null,
    adminContact: null
  },
  setup(__props: any) {

const props = __props as {
    version: string
    adminContact?: string
  }

  

  const { adminContact, version } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" v" + _toDisplayString(_unref(version)), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.ABOUT')), 1)
          ]),
          _: 1
        })
      ]),
      (_unref(adminContact))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "•"))
        : _createCommentVNode("", true),
      (_unref(adminContact))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              href: `mailto:${_unref(adminContact)}`
            }, _toDisplayString(_ctx.$t('common.CONTACT')), 9, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('common.DOCUMENTATION')), 1)
      ])
    ])
  ]))
}
}

})